export default "__VITE_ASSET__BXfEeucH__"